import { get, post } from '../helpers/api_helper';

class KYCService {
  getVerificationLink = () => {
    return post('/aml/get_verification_link');
  };
}

export const kycService = new KYCService();
